import axios from './axiosService';
import {isInteger, isObject} from 'lodash';

export default {
  getGreetingTypes() {
    return [
      {
        id: 'Formal',
        name: 'Professional (default)',
        hint: 'Uses salutation and last name when available (e.g., "Dr. Smith", "Mrs. Johnson"). Falls back to full name if no salutation is provided.'
      },
      {
        id: 'Personal',
        name: 'Personal',
        hint: 'Uses first names for a more casual approach (e.g., "John", "Sarah")',
      },
    ]
  },
  hasMedicalAttributes(team) { // MLD-3435
    if (!team) {
      return false;
    }
    // Only certain teams have this feature turned on.
    return team.can_use_crm
      && team.user_contact_medical_fields_enabled;
  },
  createContactFromEmail(email) { // MLD-6403
    const form = {
      bypass: true,
      email: email,
    }
    return axios.post(`/api/user-contacts`, form)
      .then(response => response.data);
  },
  initForm(contact = null) {
    return {
      id: contact && contact.id ? contact.id : null,
      greeting_type: contact && contact.greeting_type ? contact.greeting_type : 'Formal', // MLD-2520
      salutation: contact ? contact.salutation : '', // MLD-2520
      first_name: contact ? contact.first_name : '',
      middle_name: contact ? contact.middle_name : '', // MLD-3137
      last_name: contact ? contact.last_name : '',
      suffix: contact ? contact.suffix : '', // MLD-3137
      designation: contact ? contact.designation : '', // MLD-2520
      specialty: contact ? contact.specialty : '', // MLD-3435
      email: contact ? contact.email : '',
      title: contact ? contact.title : '', // MLD-3182
      company_name: contact ? contact.company_name : '',
      sync_from_crm: contact ? contact.sync_from_crm : true,
      is_active: contact ? contact.is_active : true,
      is_subscribed: contact ? contact.is_subscribed : true, // MLD-2844
      is_unsubscribed: contact ? contact.is_unsubscribed : false, // MLD-2844
      npi: contact ? contact.npi : null, // MLD-2704
      external_id: contact ? contact.external_id : null, // MLD-2704
      mdm_id: contact ? contact.mdm_id : null, // MLD-4391
      // MLD-2872
      address1: contact ? contact.address1 : null,
      address2: contact ? contact.address2 : null,
      address3: contact ? contact.address3 : null,
      address4: contact ? contact.address4 : null,
      locality: contact ? contact.locality : null,
      administrative_area: contact ? contact.administrative_area : null,
      postal_code: contact ? contact.postal_code : null,
      country: contact ? contact.country : null,
      timezone: contact ? contact.timezone : null,
      lists: [], // MLD-2707
    }
  },
  populateForm(contact, form) {
    form.greeting_type = contact.greeting_type; // MLD-2520
    form.salutation = contact.salutation; // MLD-2520
    form.first_name = contact.first_name;
    form.middle_name = contact.middle_name; // MLD-3137
    form.last_name = contact.last_name;
    form.suffix = contact.suffix; // MLD-3137
    form.designation = contact.designation; // MLD-2520
    form.specialty = contact.specialty; // MLD-3435
    form.email = contact.email;
    form.title = contact.title; // MLD-3182
    form.company_name = contact.company_name;
    form.sync_from_crm = contact.sync_from_crm;
    form.is_active = contact.is_active;
    form.is_subscribed = contact.is_subscribed; // MLD-2844
    form.is_unsubscribed = contact.is_unsubscribed; // MLD-2844
    form.npi = contact.npi; // MLD-2704
    form.external_id = contact.external_id; // MLD-2704
    form.mdm_id = contact.mdm_id; // MLD-4391
    // MLD-2872
    form.address1 = contact.address1;
    form.address2 = contact.address2;
    form.address3 = contact.address3;
    form.address4 = contact.address4;
    form.locality = contact.locality;
    form.administrative_area = contact.administrative_area;
    form.postal_code = contact.postal_code;
    form.country = contact.country;
    form.timezone = contact.timezone;
  },
  getEventsFor(contactID) { // MLD-5707
    return axios.get(`/api/user-contacts/${contactID}/events`)
      .then(response => response.data);
  },
  getContact(contactID) {
    return axios.get(`/api/user-contacts/${contactID}`)
      .then(response => response.data);
  },
  getContacts(form = {}) {
    return axios.get(`/api/user-contacts`, {params: form})
      .then(response => response.data);
  },
  syncFromCRM(userID, startAt = null) { // MLD-2598
    const form = { // MLD-3237
      start_at: startAt,
    }
    return axios.post(`/api/users/${userID}/contacts/sync-from-crm`, form)
      .then(response => response.data);
  },
  upload(form) { // MLD-2707
    return axios.post(`/api/user-contacts/upload`, form)
      .then(response => response.data);
  },
  search(form, user) { // MLD-2712
    const userIDs = [
      //3, // Mark
    ]
    if (isObject(user) && isInteger(user.id) && userIDs.includes(user.id)) {
      try {
        return this.searchV2(form);
      } catch (e) {
        console.debug('UserContact search exception', e.message);
      }
    }
    return this.searchV1(form);
  },
  searchV1(form) {
    return axios.post(`/api/user-contacts/search`, form)
      .then(response => response.data);
  },
  searchV2(form) { // MLD-4320
    return axios.post(`/api/user-contacts/search/v2`, form)
      .then(response => response.data);
  },
}
